// Angular Files
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

// Teller Online Files
import { CoreModule } from 'apps/admin-portal/src/app/core/core.module';

// Teller Online Library Files
import { TellerOnlineSiteMetadataService } from 'teller-online-libraries/core';

@Injectable({
    providedIn: CoreModule
})
export class PortalFeatureGuardService {
    constructor(private router: Router, private siteMetadataService: TellerOnlineSiteMetadataService) { }

    // Routes gated by the AuthenticatedUsers feature
    private _authFeatureRoutes = ['user', 'users', 'users/'];

    // Routes gated by the ScheduledPayments feature
    private _scheduledPaymentRoutes = [
        'scheduled-payments',
        'scheduled-payments/:guid'
    ];

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const { path } = route.routeConfig;

        if (!this.siteMetadataService.authenticationEnabled
            && this._authFeatureRoutes.includes(path)) {
            this.router.navigate(['/']);
            return false;
        }

        if (!this.siteMetadataService.scheduledPaymentsEnabled
            && this._scheduledPaymentRoutes.includes(path)) {
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }
}
